import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { FavoriteToggle } from '~src/favorites/components/favoriteToggle/FavoriteToggle';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CardPopoverWidget, ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { Thumbnail } from '~src/spacesPlatform/components/card/Thumbnail';

import { ViewTooltip } from './ViewTooltip';


export const ViewDefaultImageUrl = imgPath('spaces_card_view.svg');

export class ViewCard extends ContentCard {
  public render() {
    const {
      content, inRecentsSpace, urls, hovered, selected, allowDragAndDrop, addContentFavorite, removeContentFavorite
    } = this.props;
    const showLastAccessedAt = inRecentsSpace || this.props.showLastAccessedAt;

    return (
      <div className={CardViewStyles.Card}>
        <Thumbnail
          navigateUrl={getContentUrlForItem(content, urls)}
          defaultImageUrl={ViewDefaultImageUrl}
          thumbnailImageUrl={content.thumbnailUrl}
          hovered={hovered}
          selected={selected}
          allowDragAndDrop={allowDragAndDrop}
          aria-label={content.name}
        />
        <div className={CardViewStyles.ActionRow}>
          <span data-tb-test-id="view-name" className={CardViewStyles.ActionRowName} title={content.name}>
            {content.name}
          </span>
          <span>
            <CardPopoverWidget
              content={content}
              onTriggerClick={this.handleShowPopover}
              popoverContent={this.renderPopoverContent()}
              title={Messages.viewTooltipTitle()}
            />
          </span>
         <span>
            <FavoriteToggle isTabbable={true}
              isFavorite={content.favorite}
              onAddFavorite={() => addContentFavorite({ ...content, contentType: 'view' })}
              onRemoveFavorite={() => removeContentFavorite({ ...content, contentType: 'view' })} />
          </span>
          {this.renderActionsMenu()}
        </div>
        {
          showLastAccessedAt ? (
            <div className={CardViewStyles.CardLastAccessedAt}>
              {this.getLastAccessedAt()}
            </div>
          ) : (
            <div className={CardViewStyles.CardDescription}>
              {this.getDescription()}
            </div>
          )
        }
      </div>
    );
  }

  private renderPopoverContent = () => <ViewTooltip content={this.props.content}
      urls={this.props.urls}
      inProjectSpace={this.props.inProjectSpace}
      inPersonalSpace={this.props.inPersonalSpace} />;
}
